/**
 * Created by andrey on 01.07.2024
 */

const VirtualUrl = function (bundleName, key, data) {
    VirtualResource.call(this, bundleName, key);

    this.parse(data);
};

VirtualUrl.prototype = Object.create(VirtualResource.prototype);
VirtualUrl.prototype.constructor = VirtualUrl;

cc.VirtualUrl = VirtualUrl;

VirtualUrl.prototype.parse = function (data) {
    if (data.type) {
        this.type = data.type;
        this.name = data.name;
        this.srcs = data.srcs;
    } else if (data && data.fromSource) {
        this.fromSource = true;
        this.url = data.url;
        this.regionSource = data.regionSource;
    } else {
        this.url = data;
    }
};

VirtualUrl.prototype.isSound = function () {
    return typeof this.url === "string" && (this.url.includes("/sfx/") || this.url.endsWith(".mp3"));
};

VirtualUrl.prototype.isImage = function () {
    return typeof this.url === "string" && [".png", ".jpg"].includes(cc.path.extname(this.url));
};

VirtualUrl.prototype.isImportant = function () {
    const bundle = bundles[this.bundleName];

    return bundle.important && bundle.important[this.key]
        || cleverapps.config.debugMode && cleverapps.dataLoader.load(DataLoader.TYPES.TEST_SOUNDS) === "wait_all";
};

VirtualUrl.prototype.expandUrl = function (url) {
    if (typeof url !== "string") {
        return url;
    }

    const staticUrl = cleverapps.config.staticUrl || "";

    switch (url.charAt(0)) {
        case "$":
            return `${staticUrl}res/packed/sounds/${url.substring(1)}`;
        case "@":
            if (!cleverapps.resolution.isInitialized()) {
                throw new Error(`${this.toString()} can't expand url while resolution is not defined`);
            }
            return `${staticUrl}res/packed/${this.bundleName}/${cleverapps.resolution.resolutionName}/${url.substring(1)}`;
        case "~":
            return `${staticUrl}res/packed/${url.substring(1)}`;
        default:
            return url;
    }
};

VirtualUrl.prototype.getUrl = function () {
    if (this.fromSource) {
        return this.expandUrl(this.url);
    }

    if (this.type) {
        return {
            type: this.type,
            name: this.name,
            srcs: this.srcs.map((src) => this.expandUrl(src))
        };
    }

    return this.expandUrl(this.url);
};

VirtualUrl.prototype.save = function () {
    if (this.type) {
        return { type: this.type, name: this.name, srcs: this.srcs };
    }
    if (this.fromSource) {
        return { fromSource: true, url: this.url };
    }
    return { url: this.url };
};